/* eslint-disable @typescript-eslint/no-explicit-any */
import Empty from '../Empty'
import ProductWithIntersectionalBanners from './ProductWithIntersectionalBanners'

const ProductDisplayLayout = ({
  products,
  hasMoreData,
  trackSource,
  onProductClick,
  fetchMoreData,
  searchValue,
}: any) => {
  if (!products?.length) {
    return <Empty />
  }

  return (
    <ProductWithIntersectionalBanners
      searchValue={searchValue}
      products={products}
      onProductClick={onProductClick}
      fetchMoreData={fetchMoreData}
      hasMoreData={hasMoreData}
      trackSource={trackSource}
    />
  )
}

export default ProductDisplayLayout
